import React, { Component } from 'react';
import AnnouncementsDetail from './../../Global/Modules/AnnouncementDetail'

class Mededeling extends Component {

    render() {
        return (
            <div className="route">
                <AnnouncementsDetail niew={window.location.pathname.split("/")[3]} />
            </div>
        );
    }
}

export default Mededeling;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Mededeling.js